<ion-content [scrollY]="false" [scrollX]="false" slot="fixed">
  <div class="login__background"></div>
  <!-- Logo -->
  <div class="login__logo" [class.staging]="isStagingEnv">
    <img src="/assets/images/logo-yova.png" alt="Logo yova" />
  </div>
  <!-- Content -->
  <div class="container container--center">
    <div class="login__logged-user">
      <h1>{{ 'ACCOUNT.2fa.login.title' | translate }}</h1>
      <p class="email">{{ 'ACCOUNT.2fa.login.p' | translate:{ phoneNumber: phoneNumber | phone:true } }}</p>
      <app-otp-code [code]="resetOtp" (update)="otpCodeUpdate($event)"></app-otp-code>
    </div>
  </div>
  <div class="login__signup">
    <p>
      <a (click)="resendCode()">{{ 'ACCOUNT.2fa.code.resend' | translate }}</a>
      <span>·</span>
      <a (click)="needHelp()">{{ 'ACCOUNT.2fa.code.needHelp' | translate }}</a>
    </p>
  </div>
</ion-content>
